import React, {useEffect, useState} from "react";
import ReviewShortContent from "@Pages/reviewWidget/components/ReviewShortContent";
import ExpandReviewButton from "@Pages/reviewWidget/components/ExpandReviewButton";
import FullReview from "@Pages/reviewWidget/components/FullReview";
import Row from "@Containers/components/Row";
import {Colors} from "@Styles/Colors.style";

function ReviewMobile({review}) {
    const [isActive, setIsActive] = useState(false)
    const [activeClass, setActiveClass] = useState("")

    useEffect(() => {
        setActiveClass(isActive ? "gb--review-snippet-small-active" : "")
    }, [isActive]);


    return (
        <div
            className={`gb--review-snippet gb--review-snippet-small ${activeClass}`}
            onClick={() => setIsActive(!isActive)}
            style={{borderRightColor: Colors.secondaryColor}}
        >
            <Row justify>
                <ReviewShortContent review={review}/>
                <ExpandReviewButton
                    isInactive={!isActive}
                    direction={isActive ? "up" : "down"}
                />
            </Row>
            {isActive && <FullReview review={review}/>}
        </div>
    )
}

export default ReviewMobile;